import {Component, ViewChild} from '@angular/core';
import {IonicPage, NavController, NavParams, Refresher} from 'ionic-angular';
import {MyChairPage} from "../my-chair/my-chair";
import {StaffServiceProvider} from "../../providers/staff-service/staff-service";
import {TabsServiceProvider} from "../../providers/tabs-service/tabs-service";

@IonicPage()
@Component({
  selector: 'page-my-chair-multiple-shop',
  templateUrl: 'my-chair-multiple-shop.html',
})
export class MyChairMultipleShopPage {

  public loading: boolean;
  public staffId: string;
  public staff: any;
  public currentTeam: any;

  @ViewChild(Refresher) refresher: Refresher;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public staffProvider: StaffServiceProvider,
    public tabsService: TabsServiceProvider
  ) {

  }

  ionViewDidLoad() {
  }

  ionViewWillEnter(){
    this.tabsService.show();
  }

  ionViewDidEnter() {
    this.loading = true;
    this.staffId = localStorage.getItem('tuid');
    this.staffProvider.getStaff(this.staffId).then((staff: any) => {
      this.staff = staff;
      staff.teams.forEach((team) => {
        if (team.id === this.staff.current_active_team){
          this.currentTeam = team;
        }
      });
      this.loading = false;
    }).catch(error => {
      this.loading = false;
    })
  }

  openMyChair(team) {
    if (!this.staff.current_active_team) {
      this.loading = true;
      this.staffProvider.toggleCheckIn(true, team.id, this.staffId).then((res:any) => {
        this.loading = false;
        localStorage.setItem('currentTeamId', res);

        this.navCtrl.push(MyChairPage, {
          staffHasMultipleShops: true,
          staffId: this.staff.id,
          teamId: team.id
        })
      }).catch(error => {
        this.loading = true;
      });
    } else {
      this.navCtrl.push(MyChairPage, {
        staffHasMultipleShops: true,
        staffId: this.staff.id,
        teamId: team.id
      })
    }
  }

  title(staff) {
    if (staff.current_active_team === null) return `Hey there ${staff.name}! What shop are you working in today?`;

    return `Hey there ${staff.name}! You’re currently checked in at ${this.currentTeam.name}`
  }

  pullToRefresh() {
    this.staffProvider.getStaff(this.staffId).then((staff: any) => {
      this.staff = staff;
      this.refresher.complete();
    }).catch(() => {
      this.refresher.complete();
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/my-chair-multiple-shop/my-chair-multiple-shop.ts